/// <amd-module name="Wit/LinkedWorkItemsDropdown/LinkedWorkItemsChangesetDetailViewService" />
import { IWorkItemEntry } from "Util/Data";
import { IReadyableReadonlyObservableArray } from "VSS/Core/Observable";
import { IVssPageContext, IVssService, Services } from "VSS/Platform/Context";
import { LinkedWorkItemsBaseDetailViewService } from "./LinkedWorkItemsBaseDetailViewService";
import { getLinkedWorkItemsService } from "./LinkedWorkItemsService";

export interface ILinkedWorkItemsChangesetDetailViewService extends IVssService {
    getLinkedWorkItems(projectId: string, repositoryId: string, changesetId: number): IReadyableReadonlyObservableArray<IWorkItemEntry>;
}

class LinkedWorkItemsChangesetDetailViewService extends LinkedWorkItemsBaseDetailViewService implements ILinkedWorkItemsChangesetDetailViewService {
    public getLinkedWorkItems(projectId: string, repositoryId: string, changesetId: number): IReadyableReadonlyObservableArray<IWorkItemEntry> {
        return super.getLinkedWorkItems(projectId, repositoryId, changesetId);
    }
    protected getLinkedWorkItemPromise(projectId: string, repositoryId: string, changesetId: number): Promise<number[]> {
        const linkedWorkItemService = getLinkedWorkItemsService(this.pageContext);
        return linkedWorkItemService.getLinkedChangesetWorkItemIds(changesetId);
    }
}

const serviceName = "ILinkedWorkItemsChangesetDetailViewService";
export function getLinkedWorkItemsChangesetDetailViewService(pageContext: IVssPageContext): ILinkedWorkItemsChangesetDetailViewService {
    return pageContext.getService<ILinkedWorkItemsChangesetDetailViewService>(serviceName);
}

Services.add(serviceName, { serviceFactory: LinkedWorkItemsChangesetDetailViewService });
